import { createMcpServer, initializeMcpServer } from './core/server.js';
import { StdioServerTransport } from '@modelcontextprotocol/sdk/server/stdio.js';
import logger from './utils/logger.js';

/**
 * Main entry point for the MCP server
 * This file uses STDIO transport by default, but you can use http.ts or stdio.ts directly
 */
async function main() {
  try {
    logger.info('Starting Artillery Performance MCP Server');
    
    // Create and initialize the MCP server
    const server = createMcpServer();
    await initializeMcpServer(server);
    
    // Create and connect the STDIO transport
    const transport = new StdioServerTransport();
    logger.info('Connecting STDIO transport to MCP server');
    
    await server.connect(transport);
    logger.info('MCP server successfully started with STDIO transport');
  } catch (error) {
    logger.error(`Error starting MCP server: ${error}`);
    process.exit(1);
  }
}

// Start the server
main().catch(error => {
  logger.error(`Unhandled error: ${error}`);
  process.exit(1);
});
